import {
  RugbyUnionIncidentId,
  RugbyUnionRuckAttribute,
} from '@collector/sportsapi-client-legacy'

import { IncidentsQueuePayloadConfig } from '../../../configuration'
import { addIncidentAndUpdatePossession } from '../../configuration'

export const incidentsQueuePayloadConfig: IncidentsQueuePayloadConfig<RugbyUnionIncidentId> =
  {
    [RugbyUnionIncidentId.Ruck]: {
      addIncident: (payload, queue) => {
        queue.addIncident({
          ...payload,
          attribute_ids: [RugbyUnionRuckAttribute.Won],
        })
      },
    },
    [RugbyUnionIncidentId.Kick]: {
      addIncident: addIncidentAndUpdatePossession,
    },
    [RugbyUnionIncidentId.Offload]: {
      addIncident: addIncidentAndUpdatePossession,
    },
    [RugbyUnionIncidentId.Lineout]: {
      addIncident: addIncidentAndUpdatePossession,
    },
    [RugbyUnionIncidentId.Maul]: {
      addIncident: addIncidentAndUpdatePossession,
    },
    [RugbyUnionIncidentId.Scrum]: {
      addIncident: addIncidentAndUpdatePossession,
    },
    [RugbyUnionIncidentId.SubstitutionIn]: {
      addIncident: (payload, queue) => {
        const substitutionOutUuid = queue.addIncident({
          ...payload,
          incident_id: RugbyUnionIncidentId.SubstitutionOut,
        })
        queue.addIncident(
          {
            ...payload,
            incident_id: RugbyUnionIncidentId.SubstitutionIn,
          },
          substitutionOutUuid,
        )
      },
    },
  }
